export default {
  route: {
    dashboard: '首页',
    applications: '应用',
    billing: '账单',
    log: '日志',
    aiCallRecord: '处理记录',
    creditLog: '学分日志',
    statistics: '统计',
    team: '团队',
    teamMember: '团队成员',
    ticket: '工单',
    ticketDetail: '工单详情'
  },
  tagsView: {
    refresh: '刷新',
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  },
  common: {
    logout: '退出登录',
    cancel: '取消',
    confirm: '确认',
    open: '开启',
    close: '关闭',
    success: '成功',
    failure: '失败',
    warning: '警告',
    error: '错误',
    info: '提示',
    search: '搜索',
    copy: '复制',
    reset: '重置',
    create: '创建',
    export: '导出',
    exporting: '导出中',
    exportIntro: '1. 异步导出<br/>2. 根据已选条件进行导出<br/>3. 导出任务完成后即可在导出数据中进行下载',
    detail: '详情',
    edit: '编辑',
    delete: '删除',
    download: '下载',
    basicInfo: '基础信息',
    basicData: '基础数据',
    exportData: '导出数据',
    pleaseEnter: '请输入',
    pleaseCheckSearchResults: '请选中搜索结果',
    operating: '操作',
    operatingSuccess: '操作成功',
    operatingFailure: '操作失败',
    confirmOpen: '确认开启吗？',
    confirmClose: '确认关闭吗？',
    confirmDelete: '确认删除吗？',
    condition: '条件',
    dataVolume: '数据量',
    aiName: 'AI名称',
    email: '邮箱',
    phone: '手机号',
    name: '名称',
    intro: '介绍',
    type: '类型',
    status: '状态',
    createTime: '创建时间',
    updateTime: '更新时间',
    more: '更多',
    validityPeriod: '有效期为24小时，过期将自动删除。',
    time: '时间',
    byHour: '按时',
    byDay: '按日',
    byMonth: '按月',
    byYear: '按年',
    frequency: '次数',
    confirmExit: '确认退出吗？',
    team: '团队',
    manage: '管理',
    quit: '退出',
    member: '成员',
    add: '添加',
    other: '其它',
    uploadAttachment: '上传附件',
    attachment: '附件',
    uploadText: '将文件拖到此处 或 点击上传',
    uploadTip105: '单个附件不得超过10M，最多上传5个附件',
    uploadSizeLimit10: '单个附件不得超过10M',
    uploadFileFail: '上传文件失败',
    awaitingProcessing: '待处理',
    inProgress: '处理中',
    processed: '已处理',
    resolved: '已解决',
    confirmResolved: '确认已解决吗？',
    supportTeam: '支持团队',
    send: '发送',
    ticketNotificationTitle: 'AI发型设计工单新进展',
    ticketNotificationContent: '您提交的 {ticketNo} 工单有新的进展!',
    second: '秒'
  },
  validate: {
    notEmpty: '{name} 不能为空',
    format: '{name} 格式不正确'
  },
  applications: {
    applications: '应用',
    createApplications: '创建应用',
    createApplicationsIntro: '创建应用，获取API KEY',
    confirmResetApiKey: '确认重置API KEY吗？'
  },
  doc: {
    callServices: '调用服务',
    buyingGuide: '购买指南',
    priceDoc: '计费介绍'
  },
  price: {
    buy: '购买',
    personalized: '定制化',
    public: '公共',
    moreIntro: '如果您需要更多的学分，请通过以下方式联系我们：',
    weChatPay: '微信支付',
    aliPay: '支付宝支付',
    apiCannotBuyCredit: '该API暂未开放学分售卖功能。',
    scanPay: '扫码付款',
    payChannel: '支付方式',
    limitInfo: '限额信息',
    smallChange: '微信零钱',
    smallChangeLimit: '以微信限额为准',
    bankCard: '微信绑定的银行卡',
    bankCardLimit: '以银行限额为准',
    paySuccess: '支付成功'
  },
  billing: {
    orderNo: '订单编号',
    payChannel: '支付方式',
    paySerialNumber: '支付流水号',
    price: '金额',
    totalPrice: '总金额',
    discountedPrice: '优惠金额',
    payPrice: '支付金额',
    payPal: 'PayPal',
    paddle: 'Paddle',
    google: 'Google',
    apple: 'Apple',
    payssion: 'Payssion',
    weChatPay: '微信',
    aliPay: '支付宝',
    payStatusPaid: '已支付',
    payStatusCompleteRecharge: '已完成（充值）',
    payStatusRefunded: '已退款',
    payStatusCompleteRefund: '已完成（退款）',
    payTime: '支付时间'
  },
  credits: {
    credits: '学分',
    creditsBalance: '学分（余额）',
    creditsTotal: '学分（总数）',
    creditsDiscount: '学分（优惠）',
    creditsConsume: '学分（消耗）',
    creditsRequest: '学分/请求成功',
    creditsConsumptionIntro: '学分消耗说明',
    resourcePack: '资源包',
    aiConsume: 'AI消耗',
    buy: '购买',
    free: '免费',
    gift: '赠送'
  },
  aiCallRecord: {
    statusCode: 'HTTP Status',
    errorCode: 'Error Code',
    errorMsg: 'Error Message',
    statusInfo: '状态信息',
    requestInfo: '请求信息',
    processingTime: '处理时长'
  },
  ticket: {
    ticketNo: '工单编号',
    type: '问题类型',
    email: '通知邮箱',
    emailIntro: '如果有新的进展，我们将通过邮件的形式通知您。请将【notice@no-reply.ailabtools.com】邮箱添加到白名单内，以免错过新的进展或被标记为垃圾邮件。',
    phone: '通知手机号',
    desc: '问题描述',
    basic: '常用',
    aiProject: 'AI产品',
    aboutBuy: '购买咨询',
    aboutAccount: '账号类',
    aboutBilling: '财务类'
  }
}
